(function () {
    'use strict';

    var root = document.getElementById('smp-recycling');

    if (!root) {
        return;
    }

    var items = root.querySelectorAll('.smp-recycling-accordion--items .smp-recycling-accordion__item');
    var searchInput = document.getElementById('recycling-search-input');
    var kerbsideOnly = document.getElementById('recycling-kerbside-only');
    var noResults = document.getElementById('recycling-no-results');
    var searchForm = root.querySelector('.smp-recycling__search-form');

    function getItemSearchText(item) {
        var labelEl = item.querySelector('.smp-recycling-accordion__label');
        var badgeEl = item.querySelector('.smp-recycling-accordion__badge');
        var bodyEl = item.querySelector('.card-body');

        var label = (labelEl ? labelEl.textContent : '').toLowerCase();
        var badge = (badgeEl ? badgeEl.textContent : '').toLowerCase();
        var searchData = (item.dataset.search || '').toLowerCase();
        var body = (bodyEl ? bodyEl.textContent : '').toLowerCase();

        return [label, badge, searchData, body].join(' ');
    }

    function filterItems() {
        var query = (searchInput.value || '').toLowerCase().trim();
        var kerbsideOnlyChecked = kerbsideOnly.checked;
        var visibleCount = 0;

        items.forEach(function (item) {
            var matchesSearch = !query || getItemSearchText(item).indexOf(query) !== -1;
            var matchesKerbside = !kerbsideOnlyChecked || item.dataset.kerbside === 'true';
            var show = matchesSearch && matchesKerbside;

            item.classList.toggle('is-hidden', !show);

            if (show) {
                visibleCount += 1;
            }
        });

        noResults.hidden = visibleCount > 0;
    }

    searchInput.addEventListener('input', filterItems);
    kerbsideOnly.addEventListener('change', filterItems);

    if (searchForm) {
        searchForm.addEventListener('submit', function (event) {
            event.preventDefault();
            filterItems();
        });
    }

    filterItems();
}());
